import { SuperDrawerContent, SuperDrawerHeader, TabsWithContent, useSessionStorage } from "@homebound/beam";
import { ItemEditorHistoryTab } from "./ItemEditorHistoryTab";
import { ItemEditorProps, ItemEditorTab } from "./ItemEditorTab";
import { MaterialCatalogEditorTab } from "./MaterialCatalogEditorTab";
import { MaterialLeadTimesEditorTab } from "./MaterialLeadTimesEditorTab";

export function AdminItemsDrawer(props: ItemEditorProps) {
  const { selectedItem, isMaterialCatalogEnabled, isOptionCatalogV2Enabled } = props;
  const [selectedTab, setSelectedTab] = useSessionStorage("AdminItemsDrawer", "overview");

  const overviewTab = {
    name: "Overview",
    value: "overview",
    render: () => <ItemEditorTab {...props} />,
  };

  const attributesTab = {
    name: "Material Catalog",
    value: "materialCatalog",
    render: () => <MaterialCatalogEditorTab itemId={selectedItem!.id} />,
  };

  const materialLeadTimeTab = {
    name: "Material Lead Times",
    value: "materialLeadTimes",
    render: () => <MaterialLeadTimesEditorTab itemId={selectedItem!.id} />,
  };

  const historyTab = {
    name: "History",
    value: "history",
    render: () => <ItemEditorHistoryTab itemId={selectedItem!.id} />,
  };

  const tabs = [
    overviewTab,
    ...(selectedItem && isMaterialCatalogEnabled ? [attributesTab] : []),
    ...(selectedItem && isOptionCatalogV2Enabled ? [materialLeadTimeTab, historyTab] : []),
  ];

  return (
    <>
      <SuperDrawerHeader hideControls title={selectedItem ? `Update ${selectedItem.name}` : "Create New Item"} />
      <SuperDrawerContent>
        <TabsWithContent tabs={tabs} selected={selectedTab} onChange={setSelectedTab} />
      </SuperDrawerContent>
    </>
  );
}
